export default {
  errorDefault: 'Ocurrió un error',
  unknown: 'Desconocido',
};
